export enum HttpHeaderValue {
    
}